<template>
  <div class="main training-history">
    <Sidebar
      :current-keywords="keywords"
      :current-filters="currentFilters"
      :filter-types="filterTypes"
      @search="setKeywords"
      @add-filter="addFilter"
      @remove-filter="removeFilter"
      @remove-all-filters="removeAllFilters"
    >
      <div slot="header" class="sidebar-header">
        <TrainingMenu
          class="d-xl-none"
          title="Training History"
          current="History"
        />
        <div class="d-xl-none px-sm-3 pt-sm-3 bg-white file-folder-tabs-wrap">
          <TrainingHistoryTabs current="Learning Paths" :show-events="true" />
        </div>
      </div>
    </Sidebar>

    <TrainingMenu
      class="d-none d-xl-block pt-3"
      title="Training History"
      current="History"
    />

    <div class="d-none d-xl-flex bg-white px-3 pt-3 file-folder-tabs-wrap">
      <TrainingHistoryTabs current="Learning Paths" :show-events="true" />
    </div>

    <div class="content p-3">
      <div class="row">
        <div class="col-12">
          <transition name="fade">
            <Alert v-if="hasAlert" :alert="alert" />
          </transition>

          <div class="row d-none d-xl-flex">
            <div class="col-12 col-xl-4 mb-3 mb-xl-0 text-center text-xl-left">
              <a
                v-if="items.length > 0"
                href="#"
                @click.prevent="showExportOptions()"
                class="btn btn-info mb-3 mr-sm-1 mb-sm-0 mb-xl-3"
              >
                <span class="icon icon-download"></span>
                <span class="text">Export List</span>
              </a>
            </div>
            <div class="col-12 col-xl-4 mb-3 mb-xl-0 text-center">
              <Pagination
                class="d-inline-block"
                :total="totalPages"
                :value="parseInt(pagination.current)"
                @input="setCurrentPage"
              />
            </div>
            <div class="col-12 col-xl-4 text-center text-xl-right">
              <PageSize
                :value="parseInt(pagination.per_page)"
                @input="setPerPage"
              />
            </div>
          </div>

          <EnrollmentList
            :items="items"
            :columns="columns"
            :activeColumns="activeColumns"
            :hideNoResults="hideNoResults"
            :listEvents="listEvents"
            @sort-by="setSort"
            @swap-column="setActiveColumn"
          />

          <div class="row d-none d-xl-flex">
            <div class="col-12 col-xl-4 mb-3 mb-xl-0 text-center text-xl-left">
              <a
                v-if="items.length > 0"
                href="#"
                @click.prevent="showExportOptions()"
                class="btn btn-info mb-3 mr-sm-1 mb-sm-0 mb-xl-3"
              >
                <span class="icon icon-download"></span>
                <span class="text">Export List</span>
              </a>
            </div>
            <div class="col-12 col-xl-4 mb-3 mb-xl-0 text-center">
              <Pagination
                class="d-inline-block"
                :total="totalPages"
                :value="parseInt(pagination.current)"
                @input="setCurrentPage"
              />
            </div>
            <div class="col-12 col-xl-4 text-center text-xl-right">
              <PageSize
                :value="parseInt(pagination.per_page)"
                @input="setPerPage"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";
import ListingMixin from "mixins/Listing";
import TrainingMenu from "../partials/TrainingMenu";
import TrainingHistoryTabs from "../partials/TrainingHistoryTabs";
import EnrollmentList from "components/partials/LearningPaths/EnrollmentList";

export default {
  mixins: [DisplaysAlerts, ListingMixin],
  components: {
    TrainingMenu,
    TrainingHistoryTabs,
    EnrollmentList,
  },
};
</script>